
import { h, Fragment, render } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import { createPortal } from 'preact/compat'
import { useLocalStorage } from './hooks/useLocalStorage'
import { createModel, createUrl } from './utility/model'
import { naturalLanguageJoin } from './utility/naturalLanguageJoin'
import classnames from 'classnames'
import { json } from './utility/dom'
import { map } from './utility/object'
import { JobListing } from './components/JobListing.jsx'
import { Button } from './components/Button.jsx'


export default function init() {
	
	const siteSettings = json('#site-settings')

	const queryFromFilters = filters => {
		return createModel({
			category: filters.category || [],
			perPage: 8
		})
	}

	// hide container if no roles
	const onHideEl = el => {
		if (el.getAttribute('data-hide-no-roles'))
			return () => el?.closest('.js-jobs-hide-no-roles')?.remove()
	}

	const modules = [...document.querySelectorAll('.js-latest-jobs')]
	modules.map(el => {
		const filters = JSON.parse(el.getAttribute('data-filters') || '{}')
		render(createPortal(<LatestJobs query={queryFromFilters(filters)} siteSettings={siteSettings} onNoRoles={onHideEl(el)} />, el), el)
	})
}


function useSearch({ query, siteSettings }) {

	const [first, setFirst] = useState(true)
	const [results, setResults] = useState([])
	const [pagination, setPagination] = useState({})
	const [loading, setLoading] = useState(false)
	const [viewAllText, setViewAllText] = useState('')
	const [searchUrl, setSearchUrl] = useState('')
	
	let latestReq = null
	const request = () => {
		const urlParams = { 
			...query.getAll(), 
		}
		const api = createUrl(siteSettings.homeUrl + '/api/jobs', urlParams, true)
		const search = createUrl(siteSettings.searchUrl, {...urlParams, perPage: undefined }, false)
		latestReq = api
		setLoading(true)
		fetch(api).then(response => response.json()).then(response => {
			if (latestReq !== api) return;
			setLoading(false)
			setFirst(false)
			setSearchUrl(search)
			setResults(response.data ?? [])
			setPagination(response.pagination ?? {})
			setViewAllText(getViewAllText(query, response.facets, response.pagination))

			// trigger page layout events after a short delay
			setTimeout(() => {
				window.dispatchEvent(new Event('resize'));
			}, 100)
		})
	}

	// first load
	useEffect(request, [])
	return { results, pagination, loading, first, viewAllText, searchUrl }
}


function LatestJobs({ query, siteSettings, onNoRoles }) {

	const { 
		results, pagination, loading, viewAllText, first, searchUrl
	} = useSearch({ query, siteSettings })	

	if (!first && !results.length) return onNoRoles()

	const total = pagination.totalItems
	return <>

		<div style={loading ? 'opacity:0.5' : ''}>
			{results.map(result => <JobListing job={result} />)}
		</div>

	    {(pagination.totalItems > query.get('perPage')) && <>
			<Button 
				href={searchUrl} 
				target="_blank"
				variant="fill"
				>
				{viewAllText}
			</Button>
	    </>}
	</>
}


function getViewAllText(query, facets, pagination) {

	const total = pagination.totalItems
	if (total && (total <= query.get('perPage'))) return ''
	
	const number = total ? total : ''
	const all = (total && (total > 10)) ? `all ${number}` : number
	const s = total === 1 ? '' : 's'
	const roles = `role${s}`
	let text = `View ${all} ${roles}`
	
	const categories = query.get('category').map(id => {
		return facets?.category?.values?.[id]?.value
	})

	if (categories.length === 1) text += ` in ${categories[0]}`
	if (categories.length >= 2 && categories.length < 4) text += ` in ${naturalLanguageJoin(categories)}`
	if (categories.length >= 4) text += ` in ${categories.length} categories`

	return text
}